<template>
  <Tooltip :key="appointment.service_category.id" :options="options">
    <template #trigger>
      <div
        class="p-3 bg-white rounded-lg border hover:bg-blue-50 cursor-pointer"
      >
        <div class="text-lg font-medium">Select Technician</div>
        <div class="text-sm font-medium text-gray-500">
          Unassigned (Pending Auto-Assignment)
        </div>
      </div>
    </template>
    <template #tooltip>
      <AssignedTechnicianForm
        :appointment="appointment"
        @saved="emit('refresh-appointment')"
      />
    </template>
  </Tooltip>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Tooltip from "@/components/Tooltip.vue";
import { AppointmentV2 } from "@/typings/appointment";
import AssignedTechnicianForm from "./AssignedTechnicianForm.vue";

const emit = defineEmits(["refresh-appointment"]);
defineProps<{ appointment: AppointmentV2 }>();
const visible = ref(false);
const options = ref({
  appendTo: document.body,
  interactive: true,
  hideOnClick: true,
  distance: -10,
  arrow: false,
  placement: "bottom",
  trigger: "click",
  theme: "actions-menu light",
  onShow: () => (visible.value = true),
  onHidden: () => (visible.value = false)
});
</script>

<style lang="scss" scoped></style>
